import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';

@Component({
  selector: 'app-mapping-result-feedback',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
  templateUrl: './mapping-result-feedback.component.html',
  styleUrls: ['./mapping-result-feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MappingResultFeedbackComponent {
  feedbackList: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MappingResultFeedbackComponent>) {
  }

  ngOnInit() {
    this.feedbackList = this.data;
    console.log(this.feedbackList);
  }
}
